<template>
  <div class="vyopta-filter-expression">
    <div
      v-for="(element, index) in getElements()"
      :key="element.key"
      class="elementContainer"
    >
      <SingleFilter
        v-if="element.type === 'filter'"
        :ref="element.ref"
        :columns="columns"
        :dataset-name="datasetName"
        :excludedQuickPicks="excludedQuickPicks"
        :filter="element.filter"
        :filter-id="element.filter.id"
        class="existingFilter"
        @filter-remove-clicked="handleFilterRemoved(element.groupId, element.filter)"
        @filter-selected="handleFilterAdded(element.groupId, $event)"
        @filter-on-click="handleFilterOnClick"
      ></SingleFilter>
      <div v-if="element.type === 'groupOperator'" class="operatorContainer">
        <div
          v-if="mode === 'simple'"
          class="simpleOperator"
        ></div>
        <div
          v-if="mode !== 'simple'"
          class="operator pill clickable"
          @click="(event) => operatorClick(event, index)"
          tabindex="0"
        >
            <span class="center-pill">{{ element.group.operator }}</span>
        </div>
        <div
          v-if="selectingOperator === index && mode !== 'simple'"
          class="operatorSelect"
        >
          <div
            :class="{pill: true, selected: element.group.operator === 'and' }"
            @click="groupOperatorSelect(element.groupId, 'and')"
            tabindex="0"
          ><span class="center-pill">and</span></div>
          <div
            :class="{pill: true, selected: element.group.operator === 'or' }"
            @click="groupOperatorSelect(element.groupId, 'or')"
            tabindex="0"
          ><span class="center-pill">or</span></div>
        </div>
      </div>
      <div v-if="element.type === 'addToGroup'" class="addFilterContainer">

          <div
          class="addFilter pill"
          title="Add filter to this group"
          tabindex="0"
          @click="addFilterToGroup(element.groupId)"
        >
            <span class="center-pill"><i class="fas fa-plus-circle"></i></span>
        </div>
      </div>
      <div
        v-if="element.type === 'expressionOperator'"
        class="expressionOperator"
      >
        <div v-if="mode !== 'simple'" class="operator clickable" @click="(event) => operatorClick(event, index)">{{ localOperator }}</div>
        <div
          v-if="selectingOperator === index && mode !== 'simple'"
          class="operatorSelect"
        >
          <span
            :class="{operator: true, selected: localOperator === 'and' }"
            @click="operatorSelect('and')"
            tabindex="0"
          >
            and
          </span>
          <span
            :class="{operator: true, selected: localOperator === 'or' }"
            @click="operatorSelect('or')"
            tabindex="0"
          >
            or
          </span>
        </div>
      </div>
    </div>
    <div ref="menuContainer" class="filterMenuContainer">
      <v-menu
        ref="menu"
        class="filterMenu"
        content-class="filterMenuContent"
        :attach="true"
        bottom
        nudge-bottom="16"
        left
        nudge-left="10"
        z-index="900"
        v-if="showAddFilter()"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            height="26"
            width="26"
            v-on="on"
            @click="filterMenuClick"
          >
            <v-icon size="14" class="filterMenuButton">far fa-ellipsis-h</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="addFilterGroup" class="filterMenuListItem">
            <v-icon small class="filterMenuListItemIcon">far fa-plus-circle</v-icon>
            <span class="filterMenuListItemText">Add New Group</span>
          </v-list-item>
          <v-divider></v-divider>
<!--          <v-list-item @click="reset" class="filterMenuListItem">-->
<!--            <v-icon small class="filterMenuListItemIcon">far fa-redo</v-icon>-->
<!--            <span class="filterMenuListItemText">Reset</span>-->
<!--          </v-list-item>-->
          <v-list-item @click="removeAll" class="filterMenuListItem">
            <v-icon small class="filterMenuListItemIcon">far fa-trash-can</v-icon>
            <span class="filterMenuListItemText">Delete All</span>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="HistoricalDatasetApplyButtonContainer" v-if="shouldRenderApply"> 
      <button
        class="HistoricalDatasetApplyButton btn btn-primary"
        :disabled="!isFilterComplete"
        @click="handleSubmit(localOperator, activeFilterGroups)"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
  import FilterExpressionService from '../../../modules/assurance/services/filter.expression.service';
  import SingleFilter from '../../singleFilter/src/singleFilter.vue';
  import UtilsService from "../../../services/utils.service";

  export default {
    name: 'FilterExpression',
    components: {
      SingleFilter
    },
    props: {
      columns: { type: Array, default: () => [] },
      datasetName: { type: String, default: '' },
      excludedQuickPicks: { type: Object, default: () => {} },
      filterGroups: {
        type: Array,
        deep: true,
        default: function() {
          return FilterExpressionService.getDefaultFilterExpression();
        }
      },
      mode: { type: String, default: 'complex' },
      operator: {
        type: String,
        default: function() {
          return 'and';
        }
      },
      shouldRenderApply: {
        type: Boolean,
        default: function() {
          return false;
        }
      }
    },
    data: function () {
      this.filterGroups.forEach((group, index) => {
        if (group.groupId === undefined || typeof group.groupId !== 'string') {
          group.groupId = UtilsService.generateID();
        }
        group.filters.forEach((filter) => {
          if (filter.id === undefined || typeof filter.id !== 'string') {
            filter.id = UtilsService.generateID();
          }
        });
      });
      return {
        activeFilterGroups: [...this.filterGroups],
        localOperator: this.operator,
        selectingOperator: -1,
        isFilterComplete: false
      }
    },
    watch: {
      filterGroups: {
        deep: true,
        immediate: true,
        handler: function(filterGroups) {
          filterGroups.forEach((group, index) => {
            if (group.filters.length < 1) {
              group.filters.push({});
            }
            group.filters.forEach((filter, index) => {
              if (filter.id === undefined || typeof filter.id !== 'string') {
                filter.id = UtilsService.generateID();
              }
            });
            if (group.groupId === undefined || typeof group.groupId !== 'string') {
              group.groupId = UtilsService.generateID();
            }
          });
          this.activeFilterGroups = [...filterGroups];
        }
      },
      operator: {
        immediate: true,
        handler: function(operator) {
          this.localOperator = operator;
        }
      },
    },
    beforeDestroy: function() {
      document.removeEventListener('click', this.outsideClickListener);
      document.removeEventListener('click', this.filterMenuOutsideClickListener);
    },
    methods: {
      getElements: function () { // calculate elements programmatically so they can all be in same parent container
        let elements = [];
        this.activeFilterGroups.forEach((group, groupIndex) => {
          group.filters.forEach((filter, filterIndex) => {
            elements.push({
              type: 'filter',
              filter,
              key: 'G_' + group.groupId + '_F_' + filter.id,
              groupId: group.groupId,
              ref: 'G_' + group.groupId + '_F_' + filter.id
            });
            if (filterIndex < (group.filters.length - 1)) {
              elements.push({
                type: 'groupOperator',
                group,
                key: 'G_'+group.groupId + '_O_' + UtilsService.generateID(),
                groupId: group.groupId
              });
            }
          });
          if (isGroupComplete(group)) {
            elements.push({
              type: 'addToGroup',
              group,
              key: 'add-to-' + group.groupId,
              groupId: group.groupId
            });
          }
          if (groupIndex < (this.activeFilterGroups.length - 1)) {
            elements.push({
              type: 'expressionOperator',
              key: 'expression-add-to-' + groupIndex,
            });
          }
        });
        return elements;
      },
      reset: function() {
        this.activeFilterGroups = FilterExpressionService.getDefaultFilterExpression();
        this.$emit('filters-updated', this.activeFilterGroups);
      },
      removeAll: function() {
        this.activeFilterGroups = FilterExpressionService.getDefaultFilterExpression();
        this.$emit('filters-updated', this.activeFilterGroups);
      },
      addFilterToGroup: function(groupId) {
        let filterId = UtilsService.generateID();// this.activeFilterGroups[groupIndex].filters.length;
        this.activeFilterGroups.find(g => g.groupId === groupId).filters.push({id: filterId});

        // automatically open field selection menu
        this.$nextTick(() => {
          let filter = this.$refs['G_'+groupId + '_F_' + filterId];
          if (filter && filter.length > 0 && filter[0].$refs.selectInput) {
            filter[0].fieldHeaderClicked();
          }
        });
      },
      addFilterGroup: function() {
        let groupId = UtilsService.generateID(); // this.activeFilterGroups.length
        let filterId = UtilsService.generateID();
        this.activeFilterGroups.push({operator: 'and', filters: [{id: filterId}], groupId });

        // automatically open field selection menu
        this.$nextTick(() => {
          let filter = this.$refs['G_'+ groupId + '_F_' + filterId];
          if (filter && filter.length > 0 && filter[0].$refs.selectInput) {
            setTimeout(() => {
              filter[0].fieldHeaderClicked();
            }, 300);
          }
        });

      },
      getResultValue: function(result) {
        return result.text;
      },
      handleFilterAdded: function(groupId, newFilter) {
        let group = this.activeFilterGroups.find(g => g.groupId === groupId);
        group.filters[group.filters.findIndex(f => f.id === newFilter.id)] = newFilter;
        
        if(this.shouldRenderApply === false) {
          this.$emit('filters-updated', this.activeFilterGroups);
        } else {
          this.isFilterComplete = true;
        }
        this.$forceUpdate();
      },
      handleFilterRemoved: function(filterGroupId, filter) {
        let filterGroup = this.activeFilterGroups.find(g => g.groupId === filterGroupId);
        let filterIndex = filterGroup.filters.findIndex(f => f.id === filter.id);
        filterGroup.filters.splice(filterIndex, 1);
        if (this.activeFilterGroups.length > 1 && (filterGroup.filters.length === 0 || (filterGroup.filters.length === 1 && !filterGroup.filters[0].value))) {
          this.activeFilterGroups.splice(filterGroupId, 1);
        }
        if(this.shouldRenderApply === false) {
          this.$emit('filters-updated', this.activeFilterGroups);
        } else {
          this.isFilterComplete = true;
        }
      },
      handleOperatorChanged: function(operator, filterGroup) {
        filterGroup.operator = operator;
        this.$emit('filters-updated', this.activeFilterGroups);
      },
      handleSubmit: function(operator, filterGroup) {
        this.isFilterComplete = false;
        filterGroup.operator = operator;
        this.$emit('filters-updated', this.activeFilterGroups);
      },
      handleFilterOnClick: function(event) {
        if(this.shouldRenderApply === true) {
          this.isFilterComplete = false;
        }
      },
      groupOperatorClick: function(event, index) {
        if (this.mode === 'simple') {
          return;
        }
        this.selectingOperator = index;
        event.stopImmediatePropagation();
        document.addEventListener('click', this.outsideClickListener);
      },
      groupOperatorSelect: function(groupId, operator) {
        this.activeFilterGroups.find(g => g.groupId === groupId).operator = operator;
        this.selectingOperator = -1;
        if(this.shouldRenderApply === false) {
          this.$emit('filters-updated', this.activeFilterGroups);
        } else {
          this.isFilterComplete = true;
        }
      },
      operatorClick: function(event, index) {
        if (this.mode === 'simple') {
          return;
        }
        this.selectingOperator = index;
        event.stopImmediatePropagation();
        document.addEventListener('click', this.outsideClickListener);
      },
      operatorSelect: function(operator) {
        this.localOperator = operator;
        this.selectingOperator = -1;
        let url = this.$options.parent.$el.baseURI;
        if(this.shouldRenderApply === false) {
            this.$emit('operator-changed', operator);
            document.removeEventListener('click', this.outsideClickListener);
        } else {
          this.isFilterComplete = true;
        }
      },
      outsideClickListener: function() {
        this.selectingOperator = undefined;
        this.activeFilterGroups.forEach(group => group.isSelectingOperator = false);
        this.$forceUpdate();
        document.removeEventListener('click', this.outsideClickListener);
      },
      filterMenuClick: function() {
        document.addEventListener('click', this.filterMenuOutsideClickListener);
      },
      filterMenuOutsideClickListener: function() {
        if (this.$refs.menu) {
          this.$refs.menu.save();
        }
        document.removeEventListener('click', this.filterMenuOutsideClickListener);
      },
      showAddFilter: function() {
        if (this.mode === 'simple') {
          return false;
        }
        let hasEmptyFilterGroup = false;
        this.activeFilterGroups.forEach(function(filterGroup) {
          if (filterGroup.filters.length === 0 || (filterGroup.filters.length === 1 &&
                                                   !filterGroup.filters[0].auto &&
                                                   !filterGroup.filters[0].filterComplete &&
                                                   !filterGroup.filters[0].isQuickPick)) {
            hasEmptyFilterGroup = true;
          }
        });
        return !hasEmptyFilterGroup;
      }
    }
  };
  function isGroupComplete(group) {
    let allFiltersComplete = true;
    if (!group.filters) {
      return false;
    }
    group.filters.forEach((filter) => {
      if (!filter.filterComplete && !filter.auto && !filter.isQuickPick && !filter.isQuickStart) {
        allFiltersComplete = false;
      }
    })
    return allFiltersComplete;
  }
</script>

<style lang="scss" scoped>
.vyopta-filter-expression {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  .elementContainer {
    line-height: 9px; // hack to eliminate empty space under "in" combos
    margin-bottom: 8px;
    .expressionOperator {
      width: 50px;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: var(--filter-text-color);
      margin-top: 22px;
      position: relative;
      .operator {
        width: 40px;
        &.clickable {
          cursor: pointer;
          &:hover {
            background-color: var(--background-color);
          }
        }
        border-radius: var(--border-radius);
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
      }
      .operatorSelect {
        font-size: 14px;
        font-weight: 600;
        position: absolute;
        right: 5px;
        top: 37px;
        border: 1px solid #E1E1E1;
        border-radius: var(--border-radius);
        overflow: hidden;
        color: var(--filter-text-color);
        background-color: var(--panel-background);
        display: inline-block;
        width: 40px;
        text-align: center;
        z-index: 10000;
        .operator {
          display: block;
          border-radius: 0px;
          margin: 0;
          height: 30px;
          line-height: 30px;
        }
        .operator.selected {
          background-color: var(--default-color);
          color: var(--primary-btn-color);
          width: 100%;
        }
      }
      &:hover {
        .remove-filter {
          visibility: visible;
        }
      }
    }
    .existingFilter {
      display: inline-block;
    }
    .operatorContainer {
      position: relative;
      .operator {
        position: relative;
        margin: 0px 5px;
        margin-top: 22px;

        &.pill {
          margin-left: 5px;
          margin-right: 5px;
        }
      }
      .simpleOperator {
        width: 15px;
      }
    }
    .operator.clickable:hover {
      color: var(--default-color);
      background-color: var(--background-color);
      .remove-filter {
        visibility: visible;
      }
    }
    .operatorSelect {
      font-size: 14px;
      font-weight: 600;
      position: absolute;
      right: 5px;
      top: 37px;
      border: 1px solid #E1E1E1;
      border-radius: var(--border-radius);
      overflow: hidden;
      color: #8B8B8B;
      display: inline-block;
      width: 40px;
      text-align: center;
      z-index: 10000;
      .operator {
        display: block;
        border-radius: 0px;
        margin: 0;
        height: 30px;
        line-height: 30px;
      }
      .operator.selected {
        background-color: var(--default-color);
        color: var(--primary-btn-color);
        width: 100%;
      }

      .pill {
        background-color: var(--secondary-btn-bg-color);
        color: var(--filter-text-color);
        display: block;
        border-radius: 0px;
        margin: 0;
        height: 30px;
        line-height: 30px;
      }
      .pill.selected {
        background-color: var(--primary-btn-bg-color);
        .center-pill {
          color: var(--primary-btn-color);
        }
        width: 100%;
      }
    }
    .newFilter {
      display: inline-block;
      width: 220px;
    }
    .headerPlaceholder {
      display: inline-block;
      height: 16px;
      width: 100%;
    }
    .addFilterContainer {
      display: contents;
      .addFilter.pill {
        cursor: pointer;
        .center-pill {
          color:  var(--default-color);
          &:hover {
            color: var(--hover-color);
          }
        }
        font-size: 26px; //30
        width: 28px; //35
        position: relative;
        margin-top: 22px;
        margin-left: 5px;
        background-color: unset;
      }
    }
    .pill {
      font-size: 14px;
      font-weight: 600;
      line-height: 25px;
      background-color: var(--filter-bg-color);
      border-radius: var(--border-radius);
      width: 40px;
      height: 30px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center-pill {
      display: inline-flex;
      justify-content: center;
      color: var(--text-color);
      .clickable &:hover {
        color: var(--hover-color);
      }
    }
  }
  .filterMenuContainer {
    position: relative;
    margin-top: 24px;
    margin-left: 5px;
    margin-bottom: 10px;
    .filterMenuListItemIcon {
      color: var(--text-color);
    }
  }
  .HistoricalDatasetApplyButtonContainer {
   position: relative;
   margin-top: 18px;
   margin-left: 5px;
  }
}
</style>
<style lang="scss">
.vyopta-filter-expression {
  .filterMenuContainer .filterMenu .filterMenuContent {
    width: 180px;
    border-color: #eee;
    box-shadow: 0px 3px 6px #00000040;
    .v-list {
      padding-top: 6px;
      padding-bottom: 6px;
      background-color: var(--panel-background);
      color: var(--text-color);
      .v-list-item {
        cursor: pointer;
        &:hover {
          background-color: var(--active-background);
        }
        
        span {
          margin-left: 10px;
        }
      }
      .v-divider {
        margin-top: 6px;
        margin-bottom: 6px;
      }
    }
  }
  .filterMenuContainer .filterMenuButton {
    color: var(--text-color);
    &:hover {
      color: var(--hover-color);
    }
  }
}
</style>
